// @ts-nocheck
import React from 'react';
import { Input, Grid, AtsTip, SectionCard, AddButton, FormNav } from '../FormField';
import { ATS_TIPS } from '../../data/initialData';

export default function CertificationsTab({ data, onChange, onBack, onNext }) {
  const update = (idx, key, val) => {
    const arr = [...data];
    arr[idx] = { ...arr[idx], [key]: val };
    onChange(arr);
  };

  const add = () =>
    onChange([
      ...data,
      { id: Date.now(), name: '', issuer: '', date: '', credentialId: '' },
    ]);

  const remove = (idx) => onChange(data.filter((_, i) => i !== idx));

  return (
    <div>
      {/* <AtsTip {...ATS_TIPS.certifications} /> */}

      {data.map((c, i) => (
        <SectionCard
          key={c.id}
          title="Certification"
          index={i}
          showRemove={data.length > 1}
          onRemove={() => remove(i)}
        >
          <Input
            label="Certification Name"
            required
            value={c.name}
            onChange={(v) => update(i, 'name', v)}
            placeholder="AWS Certified Solutions Architect – Associate"
          />
          <Grid cols={3}>
            <Input
              label="Issuing Organization"
              value={c.issuer}
              onChange={(v) => update(i, 'issuer', v)}
              placeholder="Amazon Web Services"
            />
            <Input
              label="Date Obtained"
              value={c.date}
              onChange={(v) => update(i, 'date', v)}
              placeholder="Mar 2024"
            />
            <Input
              label="Credential ID"
              hint="optional"
              value={c.credentialId}
              onChange={(v) => update(i, 'credentialId', v)}
              placeholder="ABC123XYZ"
            />
          </Grid>
        </SectionCard>
      ))}

      <AddButton onClick={add} label="Add Another Certification" />

      <FormNav showBack onBack={onBack} showNext onNext={onNext} nextLabel="Next: Custom Sections →" />
    </div>
  );
}
